/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Asset DTO
 */
export interface AssetDto {
  id?: number;
  stage?: AssetDto.StageEnum;
  stageBeforeRequest?: AssetDto.StageBeforeRequestEnum;
  code?: string;
  name?: string;
  qtyScale?: number;
  refPriceUsd?: number;
  fiat?: boolean;
  manualRate?: boolean;
  disabledFromHouseLp: boolean;
  linkedFireblocksAssets: number;
}
export namespace AssetDto {
  export const StageEnum = {
    Active: 'ACTIVE',
    Disabled: 'DISABLED',
    DeactivationRequested: 'DEACTIVATION_REQUESTED',
    Deactivating: 'DEACTIVATING',
    Deactivated: 'DEACTIVATED',
  } as const;
  export type StageEnum = (typeof StageEnum)[keyof typeof StageEnum];
  export const StageBeforeRequestEnum = {
    Active: 'ACTIVE',
    Disabled: 'DISABLED',
    DeactivationRequested: 'DEACTIVATION_REQUESTED',
    Deactivating: 'DEACTIVATING',
    Deactivated: 'DEACTIVATED',
  } as const;
  export type StageBeforeRequestEnum = (typeof StageBeforeRequestEnum)[keyof typeof StageBeforeRequestEnum];
}
